import { useSelector } from "react-redux";
import { some, get } from "lodash";

/**
 * Returns true if any of the provided actions are currently loading
 *
 * @example
 * // returns true after GET_TODOS_BEGIN is dispatched and false after GET_TODOS_SUCCESS or GET_TODOS_FAILURE is dispatched
 * const loading = useLoadingState("GET_TODOS");
 * @param  {(string|string[])} actions - An action or list of actions to check for their loading state
 * @return {boolean} Returns true if any of the actions passed in are currently loading, false otherwise.
 */
const useLoadingState = actions => {
  const loadingState = useSelector(state => state.loadingState);
  if (Array.isArray(actions)) {
    return some(actions, action => get(loadingState, action));
  } else {
    return get(loadingState, actions);
  }
};

export default useLoadingState;
